import Vue from 'vue';

export const isSuccessfulResponse = (response) => response?.status >= 200 && response?.status <= 299;

// TODO: Handle when the server responds with an html with the error (such as non existing endpoint)
export const responseHandler = async (
  promise,
  {
    hasToShowToasts = true,
    hasToShowSuccessToasts = false,
    hasToShowErrorToasts = true,
    isPaginated = false,
    responseDataGetter = null,
  } = {},
) => {
  try {
    const response = await promise;

    const successApiMessage = response.data.message;
    showSuccessMessage(successApiMessage, { hasToShowToasts, hasToShowSuccessToasts });

    responseDataGetter ??= isPaginated ? getPaginatedResponseData : getResponseData;
    return responseDataGetter(response);
  } catch (error) {
    const errorMessage = getErrorMessage(error);

    if (isContentTypeJsonOfError(error)) {
      showErrorMessage(errorMessage, { hasToShowToasts, hasToShowErrorToasts });
    }

    throw new Error(errorMessage);
  }
};

const showSuccessMessage = (successMessage, { hasToShowToasts, hasToShowSuccessToasts }) => {
  if (hasToShowToasts && hasToShowSuccessToasts) {
    Vue.toasted.global.showSuccess({ message: successMessage });
  }
};

const getErrorMessage = (error) => {
  let firstSpecificApiErrorMessage = null;
  const errors = error.response?.data?.errors;

  if (errors) {
    const errorMessages = Object.values(errors);
    firstSpecificApiErrorMessage = errorMessages.flat()?.[0];
  }

  const errorApiMessage = firstSpecificApiErrorMessage ?? error.response?.data?.message;
  const otherErrorMessage = error.message;

  return errorApiMessage ?? otherErrorMessage;
};

const showErrorMessage = (errorMessage, { hasToShowToasts, hasToShowErrorToasts }) => {
  console.error(errorMessage);

  if (hasToShowToasts && hasToShowErrorToasts) {
    Vue.toasted.global.showError({ message: errorMessage });
  }
};

/**
 * @deprecated This function is no longer supported and should not be used.
 * Please use the `responseHandler` function instead.
 */
export const toastHandler = (
  promise,
  showToast = true,
  showOnlyToastErrors = false,
  responseDataGetter = getResponseDataVOld,
) => {
  return promise
    .then((response) => {
      if (showToast && !showOnlyToastErrors) {
        Vue.toasted.global.showSuccess({ message: response.data.message });
      }

      return responseDataGetter(response);
    })
    .catch((error) => {
      const customErrorMsg = error.response?.data;

      if (showToast || showOnlyToastErrors) {
        Vue.toasted.global.showError({ message: customErrorMsg ? customErrorMsg.message : error.message });
      }

      if (customErrorMsg) {
        return error.response;
      }

      return error;
    });
};

/**
 * @deprecated This function is no longer supported and should not be used.
 * Please use `getResponseData` function instead or `getPaginatedResponseData` if it is paginated.
 * Remember to wrap the api response in a envelope from the backend side using a "data" key.
 */
export const getResponseDataVOld = (response) => response;
export const getResponseDataNotWrapped = ({ data }) => data;

export const getResponseData = ({ data }) => data.data;
export const getPaginatedResponseData = ({ data }) => {
  const nextCursorPagination = data.links.next?.split('cursor=')[1];
  const previousCursorPagination = data.links.prev?.split('cursor=')[1];

  return {
    data: data.data,
    nextCursorPagination,
    previousCursorPagination,
  };
};

export const getContentTypeOfError = (error) => error.response.headers['content-type'];
export const isContentTypeJsonOfError = (error) => getContentTypeOfError(error).indexOf('application/json') !== -1;
export const isUnauthenticatedError = (err) => err.response?.status === 401;
